/* Finsbury China: makes the basket's order note easier to find (cart drawer and cart page).
   Loaded by snippets/fc-cart-polish.liquid.
   - Renames the theme's "Special instructions" to "Order note", the wording used across
     the site ("add an order note in your basket").
   - Adds an example of what to write as the placeholder.
   - Opens the note box automatically when the basket has a set in it (Set of 2/6/12/36),
     because that's when customers need it to tell us their mix of designs.
     If they close it themselves, it stays closed. */
(function () {
  var LABEL = 'Order note';
  var HINT = 'Mixing designs in a set? Tell us which ones, e.g. 3 Pink Hearts and 3 Blue Stripes.';
  var userClosed = false;

  function basketHasSet() {
    return [].some.call(document.querySelectorAll('.cart-items__variant'), function (v) {
      return /set of \d+/i.test(v.textContent);
    });
  }

  function apply() {
    var notes = document.querySelectorAll('textarea[name="note"]');
    if (!notes.length) return;
    var hasSet = basketHasSet();
    [].forEach.call(notes, function (ta) {
      if (ta.placeholder !== HINT) ta.placeholder = HINT;
      var details = ta.closest('details');
      if (!details) return;
      var label = details.querySelector('.cart-note__label');
      if (label && label.textContent.trim() !== LABEL) label.textContent = LABEL;
      var srLabel = details.querySelector('label[for="' + ta.id + '"]');
      if (srLabel && srLabel.textContent.trim() !== LABEL) srLabel.textContent = LABEL;
      var summary = details.querySelector('summary');
      if (summary && !summary.dataset.fcNote) {
        summary.dataset.fcNote = '1';
        // A tap on the heading while it's open means the customer is closing it
        summary.addEventListener('click', function () { if (details.open) userClosed = true; });
      }
      if (hasSet && !details.open && !userClosed) details.open = true;
    });
  }

  // The basket re-renders whenever items change, so re-apply after each change
  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; apply(); }, 120);
  }
  function start() {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();